import React, {Component} from 'react'
import ReactStreetview from 'react-streetview'

class StreetView extends Component {

  state = {
    longitude: 0,
    latitude: 0,
    showStreetView: false
  }

  componentDidMount() {
    window.StreetViewComponent = this
  }

  toggleStreetView() {
    this.setState(prevState => ({showStreetView: !prevState.showStreetView}))
  }

  render() {
    // see https://developers.google.com/maps/documentation/javascript
    const googleMapsApiKey = 'AIzaSyCYMdGkgys4NPfEuou5b0N90qOG27lmits'

    // see https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanoramaOptions
    const streetViewPanoramaOptions = {
      pov: {heading: 100, pitch: 0},
      zoom: 1,
      addressControl: false,
      fullscreenControl: false,
      motionTrackingControl: false,
      motionTracking: false
    }


    return (
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }}>
        {
          this.state.showStreetView && <ReactStreetview
            apiKey={googleMapsApiKey}
            streetViewPanoramaOptions={{
              ...streetViewPanoramaOptions,
              position: {lat: this.state.latitude, lng: this.state.longitude}
            }}
          />
        }

      </div>
    )

  }
}

export default StreetView



// WEBPACK FOOTER //
// ./src/Components/StreetView.js